export default __webpack_public_path__ + "static/media/image1.8c14ca45.jpg";